import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RestDataService} from '../../../services/rest-data.service';
import {SearchSort, SmallSelectItem} from '../../../services/common-datatypes';
import {RequiredInput} from '../../../decorators/common.decorators';
import {CommonFunctionsService} from '../../../services/common-functions.service';

@Component({
    selector: 'app-sort-select',
    templateUrl: './sort-select.component.html',
    styleUrls: ['./sort-select.component.scss']
})
export class SortSelectComponent implements OnInit {

    public selectColumnList: SmallSelectItem[] = [];
    public showDirection = false;
    @Input() inline = false;
    @Input() autoOpen = false;
    @Input() public multiple = false;
    @Input() @RequiredInput sortData!: SearchSort;
    @Output() sortDataChange = new EventEmitter<SearchSort>();

    private translatedNames: { [index: string]: string } = {};

    constructor(private dataService: RestDataService,
                private commonFunctions: CommonFunctionsService) {
        this.commonFunctions.getSortTranslations(this.translatedNames);
    }

    ngOnInit() {
        this.testShowDirection();
        this.loadData();
    }

    testShowDirection() {
        this.showDirection = (0 < this.sortData.sortItems.length);
    }

    loadData() {
        if (0 === this.selectColumnList.length) {
            this.dataService.getDeviceSort().then((data: SmallSelectItem[]) => {
                if (data && (0 < data.length)) {
                    data.forEach((item) => {
                        const newItem = new SmallSelectItem();
                        newItem.updateFromJson(item);
                        newItem.name = this.translatedNames[item.name];
                        this.selectColumnList.push(newItem);
                    });
                }
            });
        }
    }

    direction() {
        if (this.sortData.direction === '-') this.sortData.direction = '+';
        else this.sortData.direction = '-';
        this.sortDataChange.emit(this.sortData);
    }

    updateData() {
        this.testShowDirection();
        this.sortDataChange.emit(this.sortData);
    }

}
